import { CheckCircle, Shield, Clock } from 'lucide-react'

interface TrustStripProps {
  variant?: 'light' | 'dark'
  /**
   * Loader-fed count of leads processed in the recent window (typically 30d).
   * When provided and > 0, replaces the static "3 devis sous 48h" claim with
   * an honest dynamic figure: "X+ devis traités ce mois".
   */
  recentLeadCount?: number
}

// Static brand-volume figure. Conservative public claim; safe to display
// without loader data because it is not time-bounded. Exported so it can be
// reused by other trust badges without diverging copy.
export const TOTAL_PROS_COUNT = '110 000+'

export function TrustStrip({ variant = 'light', recentLeadCount }: TrustStripProps) {
  const dark = variant === 'dark'
  const hasRealLeadCount = typeof recentLeadCount === 'number' && recentLeadCount > 0
  const middleLabel = hasRealLeadCount
    ? `${recentLeadCount}+ devis traités ce mois`
    : '3 devis sous 48h'
  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-x-5 gap-y-2 rounded-xl border px-4 py-3 text-xs font-medium sm:text-sm ${
        dark
          ? 'border-white/15 bg-white/10 text-white'
          : 'border-emerald-200 bg-emerald-50 text-emerald-800'
      }`}
    >
      <span className="flex items-center gap-1.5">
        <Shield className={`h-4 w-4 ${dark ? 'text-emerald-300' : 'text-emerald-600'}`} aria-hidden="true" />
        Artisans SIRET-vérifiés
      </span>
      <span className={`hidden h-3 w-px sm:block ${dark ? 'bg-white/20' : 'bg-emerald-300/40'}`} />
      <span className="flex items-center gap-1.5">
        <Clock className={`h-4 w-4 ${dark ? 'text-emerald-300' : 'text-emerald-600'}`} aria-hidden="true" />
        {middleLabel}
      </span>
      <span className={`hidden h-3 w-px sm:block ${dark ? 'bg-white/20' : 'bg-emerald-300/40'}`} />
      <span className="flex items-center gap-1.5">
        <CheckCircle className={`h-4 w-4 ${dark ? 'text-emerald-300' : 'text-emerald-600'}`} aria-hidden="true" />
        100 % gratuit · sans engagement
      </span>
    </div>
  )
}
